'use strict'

// The name of the cookie should be kept in sync with the one in src/Core/Controller/Product/LastSeen.php and in Varnish VCLs.
const COOKIE_NAME = 'product_last_seen'
// The maximum number of products should be kept in sync with the one in src/Core/Services/Product/LastSeen/Deserializer.php.
const MAX_PRODUCTS = 10

export function resetCookie(): void {
  setCookie(COOKIE_NAME, '')
}

function push(lastSeen: string): void {
  // Get existing cookie or initialize empty array.
  const existingCookie = getCookie(COOKIE_NAME)
  let productList: string[] = []

  if (existingCookie) {
    try {
      productList = JSON.parse(existingCookie)
    } catch {
      // If cookie is invalid JSON, start with empty array.
      productList = []
    }
  }

  // Remove product if it already exists (to move it to top).
  productList = productList.filter((product) => product !== lastSeen)

  // Add product to the beginning of the array.
  productList.unshift(lastSeen)

  // Limit to maximum number of products.
  productList = productList.slice(0, MAX_PRODUCTS)

  // Save updated list to cookie.
  setCookie(COOKIE_NAME, JSON.stringify(productList))
}

export default (): void => {
  const productMainElement = document.querySelector<HTMLElement>('#product-main')

  if (productMainElement) {
    const lastSeen = productMainElement.getAttribute('data-last-seen')

    if (lastSeen) {
      // The lock makes sure that pushes are not skipped when multiple pages are loaded at the same time.
      // Pushes are directly done if the browser does not support locks.
      if (navigator.locks) {
        // The request is delayed to allow loading the rest of the scripts.
        setTimeout(() => {
          void navigator.locks.request('product.last_seen.push', { mode: 'exclusive' }, () => {
            push(lastSeen)
          })
        }, 0)
      } else {
        push(lastSeen)
      }
    }
  }
}

/**
 * Get cookie value by name.
 */
function getCookie(name: string): string | null {
  const nameEQ = name + '='
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    if (cookie) {
      let trimmedCookie = cookie
      while (trimmedCookie.charAt(0) === ' ') {
        trimmedCookie = trimmedCookie.substring(1, trimmedCookie.length)
      }
      if (trimmedCookie.indexOf(nameEQ) === 0) {
        return trimmedCookie.substring(nameEQ.length, trimmedCookie.length)
      }
    }
  }
  return null
}

/**
 * Set cookie with name, value and expiration days.
 */
function setCookie(name: string, value: string): void {
  const path = document.body.getAttribute('data-default-path')
  const expires = new Date()
  // Expires in 1 year.
  expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=${path};secure`
}
